export default class DataTableAction {
  icon!: string
  title!: string
  key!: any
  action!: (item: any) => void
  permissions!: string[]
  showIf?: (item: any) => boolean

  setIcon(icon: string): DataTableAction {
    this.icon = icon

    return this
  }

  setKey(key: any): DataTableAction {
    this.key = key

    return this
  }

  setTitle(title: string): DataTableAction {
    this.title = title

    return this
  }

  setAction(action: (item: any) => void): DataTableAction {
    this.action = action

    return this
  }

  setPermissions(permissions: string[]): DataTableAction {
    this.permissions = permissions

    return this
  }

  setShowIf(visibleIf: (item: any) => boolean): DataTableAction {
    this.showIf = visibleIf

    return this
  }
}
